import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { reaction } from 'mobx';
import { ISlideCountState } from '../../store/slide-count-state';
import { SlideDataServices } from '../slide-data-services.core';
import { onServicesReady } from '../../utils/service-awaiter';

export class SlideCountManager {
    public static register(state: ISlideCountState) {
        return new SlideCountManager(state);
    }

    private constructor(private state: ISlideCountState) {
        // 现网 slideCount 一直为 0，但实际存在页数，这里统一当作不存在
        this.state.setInitialCount((window as any).preloadData?.slideCount || NaN);

        // FIX: 如果使用 promise 的话，初始化逻辑会在后续的微任务中执行，这会导致同一 tick 的代码获取不到正确页数
        // 这里通过 createEffect 监听服务是否就绪，并同步获取页数并设置页数来避免这个问题
        const { SlideAppService, ContentStatusManager } = SlideDataServices;
        onServicesReady([SlideAppService, ContentStatusManager], (slideApp, contentStatus) => {
            this.state.setSdkSlideCount(slideApp.getSlideCount() ?? NaN);

            contentStatus.onDocumentReady(() => {
                reaction(
                    () => this.getSelectionService()?.slides.length,
                    () => {
                        // 此处不取ui上的slides.length，是因为在某些场景下ui的slide长度和实际的页数不相符
                        // 比如页面初始化时，第一页同步转换，后面slide页异步转换，则ui上的长度只为1，明显不对
                        // 而sdk上的长度肯定是准确的，我们只需要监听变化然后读取sdk上的长度即可
                        this.state.setUiSlideCount(slideApp.getSlideCount());
                    },
                    { fireImmediately: true },
                );
            });

            reaction(
                () => state.slideCount,
                (count) => {
                    if (!Number.isNaN(count)) {
                        this.onSlideCountChange(count);
                    }
                },
                {
                    fireImmediately: true,
                },
            );
        });
    }

    private onSlideCountChange(slideCount: number) {
        AppServiceProvider.getInstance().waitForReady((appService: IPcEditorAppServices) => {
            appService.viewableServiceLayer.slideRenderStateManager.setPageSize(slideCount);
        });
    }

    private getSelectionService() {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)?.viewableServiceLayer
            .selectionService;
    }
}
